<template>
  <aha-tab-item title="Notifications">
    <aha-section>
      <template #header>
        <h5>Email preferences</h5>
      </template>
      <template #body>
        <div class="mb-2">
          Once in a while, email me about…
        </div>
        <div>
          <aha-checkbox v-model="emailingFeatureUpdates" class="mb-2">
            Feature updates and protips
          </aha-checkbox>
        </div>
        <div>
          <aha-checkbox v-model="emailingUsefulContents" class="mb-2">
            General useful content (on new quiz ideas, team building,
            public speaking, inspiration, and more)
          </aha-checkbox>
        </div>
        <div>
          <aha-checkbox v-model="emailingPromotions" class="mb-2">
            Special deals and promotions
          </aha-checkbox>
        </div>
        <AhaButton
          @click="handleUpdatePreferences"
          :submitting="areEmailPreferencesUpdating"
        >
          Update
        </AhaButton>
      </template>
    </aha-section>
  </aha-tab-item>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'
import UserApi from '@/api/user'

export default {
  data() {
    return {
      emailingFeatureUpdates: false,
      emailingUsefulContents: false,
      emailingPromotions: false,
      areEmailPreferencesUpdating: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    this.updatePreferenceStatus()
  },
  methods: {
    async handleUpdatePreferences() {
      const { id: userId } = this.currentUser
      this.areEmailPreferencesUpdating = true
      utils.gaTrackEvent(gaCategories.MY_ACCOUNT, 'Email preferences > Update > Submit')

      try {
        const preferences = {
          emailingPromotions: this.emailingPromotions,
          emailingUsefulContents: this.emailingUsefulContents,
          emailingFeatureUpdates: this.emailingFeatureUpdates,
        }

        await UserApi.patchUserById(userId, { preferences })

        this.currentUser.preferences = preferences
        utils.gaTrackEvent(gaCategories.MY_ACCOUNT, 'Email preferences > Update > Succeeded')
        utils.showToastSuccess('Email preferences changed successfully!')
      } catch {
        this.$emit('hasErrorOnUpdatingUser')
        utils.gaTrackEvent(gaCategories.MY_ACCOUNT, 'Email preferences > Update > Failed')
      }

      this.areEmailPreferencesUpdating = false
    },
    updatePreferenceStatus() {
      const { preferences = {} } = this.currentUser
      this.emailingFeatureUpdates = preferences.emailingFeatureUpdates
      this.emailingUsefulContents = preferences.emailingUsefulContents
      this.emailingPromotions = preferences.emailingPromotions
    },
  },

}
</script>
